<div class="card white px-0">
    <div class="title">
        <h1 class="h1 px-2">APPLICATION WIZARD</h1>
    </div>

    <ol class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-start border-0 border-bottom py-3" >
            <div class="ms-3 me-auto">
                <div class="d-flex flex-row">
                    <button mat-icon-button *ngIf="!isApp" class="bg-active color-white me-2">1</button>
                    <button mat-icon-button *ngIf="isApp" class="bg-complete color-complete me-2"><mat-icon>check</mat-icon></button>
                    <div>
                        <h2 class="h2 fs-4" [ngClass]="{'color-active':!isApp}">Configure the Application</h2>
                        <span *ngIf="!isApp">In Progress</span>
                        <span *ngIf="isApp" class="color-complete">Complete</span>
                    </div>
                </div>
            </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start border-0 border-bottom py-2">
            <div class="ms-2 w-100">
                <mat-expansion-panel [expanded]="true" class="shadow-none m-1 artifacts-list">
                    <mat-expansion-panel-header class="mat-expansion-panel-header-wizard">
                        <mat-panel-title>
                            <div class="d-flex flex-row" *ngIf="!isApp">
                                <button mat-icon-button class="me-2 border">2</button>
                                <div>
                                    <h2 class="h2 fs-4">Provide Documentation</h2>
                                    <span>Pending</span>
                                </div>
                            </div>
                            <div class="d-flex flex-row" *ngIf="isApp">
                                <button mat-icon-button *ngIf="isAnyArtifactPending()" class="me-2" [ngClass]="isAcceptanceArtifactSelected()?'border':'bg-active color-white'">2</button>
                                <button mat-icon-button *ngIf="!isAnyArtifactPending()" class="bg-complete color-complete me-2"><mat-icon>check</mat-icon></button>
                                <div>
                                    <h2 class="h2 fs-4" [ngClass]="{'color-active':!isAcceptanceArtifactSelected()}">Provide Documentation</h2>
                                    <span *ngIf="isAnyArtifactPending()">In Progress</span>
                                    <span *ngIf="!isAnyArtifactPending()" class="color-complete">Complete</span>
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ol class="list-group mt-3 ms-5">
                        <li class="d-flex flex-column align-items-start border-0">
                            <div class="ms-2-" *ngIf="artifactsByRole(true).length">
                                <div class="fw-bold">Applicant Responsibility</div>
                                <div class="mt-2">
                                    <app-app-required-item 
                                        *ngFor="let artifact of artifactsByRole(true); let index=index"
                                        [addWizObj]="addWizObj" 
                                        [artifact]="artifact" 
                                        [isApp]="isApp" 
                                        [sequenceNumber]="index">
                                    </app-app-required-item>
                                </div>
                            </div>
                            <div class="ms-2- mt-3" *ngFor="let group of agentRoleGroups()">
                                <div class="fw-bold">{{group.label}}</div>
                                <div class="mt-2">
                                    <app-app-required-item
                                        *ngFor="let artifact of group.artifacts; let index=index"
                                        [addWizObj]="addWizObj"
                                        [artifact]="artifact"
                                        [isApp]="isApp"
                                        [sequenceNumber]="index">
                                    </app-app-required-item>
                                </div>
                            </div>
                        </li>
                    </ol>
                </mat-expansion-panel>
            </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start border-0 border-bottom py-3">
            <div class="ms-3 me-auto">
                <div class="d-flex flex-row">
                    <button mat-icon-button *ngIf="isAcceptanceArtifactPending()" class="me-2" [ngClass]="!isAcceptanceArtifactSelected()?'border':'bg-active color-white'">3</button>
                    <button mat-icon-button *ngIf="!isAcceptanceArtifactPending()" class="bg-complete color-complete me-2"><mat-icon>check</mat-icon></button>
                    <div>
                        <h2 class="h2 fs-4" (click)="selectAcceptanceArtifacts();" [ngClass]="{'color-active':isAcceptanceArtifactSelected()}">Review and Sign</h2>
                        <span *ngIf="isAcceptanceArtifactPending()">Pending</span>
                        <span *ngIf="!isAcceptanceArtifactPending()" class="color-complete">Complete</span>
                    </div>
                </div>
            </div>
        </li>
    </ol>
    <!-- <div class="divider"></div>
    <p *ngIf="!isApp">Please complete the questionaire so that we can determine what is required to submit a complete application</p> -->
    
    <div class="old-UI" *ngIf="false">
        <p></p>
        <h3>Requirements for Application</h3>
        <mat-progress-bar *ngIf="isApp" mode="determinate" value="{{percentComplete}}" color="accent" style="margin-bottom:20px;margin-top:20px;"></mat-progress-bar>
        <app-app-required-item *ngFor="let item of artifacts(); let index=index" 
            [addWizObj]="addWizObj" 
            [artifact]="item" 
            [isApp]="isApp" 
            [sequenceNumber]="index"
            [schoolSystemResponsibilityStartIndex]="schoolSystemResponsibilityStart()"
        >
        </app-app-required-item>
    </div>

</div>